import type { DirectoryEntry } from "@/types";
import { formatTagLabel, getClubState, getClubCharacteristics } from "@/lib/clubs";

interface ClubListViewProps {
  clubs: DirectoryEntry[];
}

export function ClubListView({ clubs }: ClubListViewProps) {
  if (clubs.length === 0) {
    return (
      <p className="py-8 text-center text-gray-500 dark:text-gray-400">
        No clubs match your filters.
      </p>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {clubs.map((club) => {
        const state = getClubState(club);
        const characteristics = getClubCharacteristics(club);
        return (
          <div
            key={club.slug}
            className="rounded-lg border border-gray-200 p-4 transition-colors hover:border-primary dark:border-gray-700 dark:hover:border-primary-light"
          >
            <h3 className="font-semibold text-gray-900 dark:text-gray-100">
              {club.name}
            </h3>
            {state && (
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                {formatTagLabel(state)}
              </p>
            )}
            <p className="mt-2 line-clamp-2 text-sm text-gray-600 dark:text-gray-400">
              {club.description}
            </p>
            {characteristics.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-1">
                {characteristics.slice(0, 4).map((tag) => (
                  <span
                    key={tag}
                    className="rounded bg-gray-100 px-1.5 py-0.5 text-xs text-gray-700 dark:bg-gray-800 dark:text-gray-300"
                  >
                    {formatTagLabel(tag)}
                  </span>
                ))}
              </div>
            )}
            <a
              href={club.url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-block text-sm font-medium text-primary hover:underline"
            >
              Visit site &rarr;
            </a>
          </div>
        );
      })}
    </div>
  );
}
